const LessonInfo = () => {
  return (
    <div>LessonInfo</div>
  )
}

export default LessonInfo
